import { action, computed, makeObservable } from 'mobx';

import { GaPageLabel } from '../services/AnalyticsService';
import SalesFrontendRepository from '../services/SalesFrontendRepository';

import { IModalStore, ModalType } from './ModalStore';
import { Loadable } from './models/Loadable';

export default class ProductCurrentBalanceModalStore {
  public modalProps: Loadable<any> = new Loadable();

  constructor(
    private salesFrontendRepository: SalesFrontendRepository,
    private modalStore: IModalStore
  ) {
    makeObservable(this);
  }

  @action
  public openModal(productId: number, source: string, language: string): void {
    this.modalStore.openModal(ModalType.ProductCurrentBalanceModal);
    this.modalProps = Loadable.toLoadable(this.salesFrontendRepository.getProductCurrentBalanceModalProps(productId, source, language));
  }

  @computed
  public get gaPageLabel(): GaPageLabel {
    return this.modalStore.gaPageLabel;
  }
}
